/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A stat label/value pair for the position widget
 * @export
 * @interface SurfaceMyPositionStatItem
 */
export interface SurfaceMyPositionStatItem {
    /**
     * 
     * @type {string}
     * @memberof SurfaceMyPositionStatItem
     */
    label?: string;
    /**
     * Optional prefix (e.g. "#" for rank)
     * @type {string}
     * @memberof SurfaceMyPositionStatItem
     */
    valuePrefix?: string;
}

/**
 * Check if a given object implements the SurfaceMyPositionStatItem interface.
 */
export function instanceOfSurfaceMyPositionStatItem(value: object): value is SurfaceMyPositionStatItem {
    return true;
}

export function SurfaceMyPositionStatItemFromJSON(json: any): SurfaceMyPositionStatItem {
    return SurfaceMyPositionStatItemFromJSONTyped(json, false);
}

export function SurfaceMyPositionStatItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceMyPositionStatItem {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'valuePrefix': json['valuePrefix'] == null ? undefined : json['valuePrefix'],
    };
}

export function SurfaceMyPositionStatItemToJSON(json: any): SurfaceMyPositionStatItem {
    return SurfaceMyPositionStatItemToJSONTyped(json, false);
}

export function SurfaceMyPositionStatItemToJSONTyped(value?: SurfaceMyPositionStatItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'valuePrefix': value['valuePrefix'],
    };
}

